import { debug } from "@common/lib/log";
import systemFonts from "./systemFonts.json";

const systemFontsSet = new Set(systemFonts.map((f) => f.label));

let registeredGoogleFonts: Set<string>;
const ensureRegisteredGoogleFontsInitialized = () => {
  if (!registeredGoogleFonts) {
    let link = document.querySelector("#google-fonts") as HTMLLinkElement;

    const fonts = link ? (link.href.match(/family=(.*)$/) || ["", ""])[1].split("|") : [];
    registeredGoogleFonts = new Set<string>(fonts);
  }
};

const setGoogleFontsLink = () => {
  let link = document.querySelector("#google-fonts") as HTMLLinkElement;

  if (!registeredGoogleFonts.size) {
    if (link) link.remove();
  } else {
    if (!link) {
      link = document.createElement("link") as HTMLLinkElement;
      link.id = "google-fonts";
      link.rel = "stylesheet";
      link.type = "text/css";

      document.head.append(link);
    }
    link.href = `//fonts.googleapis.com/css?family=${[...registeredGoogleFonts].join("|")}`;
  }
};

export const getGoogleFontFromNames = (names: string[]) =>
  names.map((x) => x.replaceAll(" ", "+") + ":regular").join("|");

export const getGoogleFontLinkFromNames = (names: string[]) =>
  `https://fonts.googleapis.com/css?family=${getGoogleFontFromNames(names)}`;

export const isGoogleFont = (ff: any): boolean => {
  if (!ff || typeof ff !== "string") return false;

  return ff.includes(":");
};

export const getGoogleFontLabel = (x: string) => x.split(":")[0].replaceAll("+", " ");

export const isGoogleFontLabel = (ff: any): boolean => {
  if (!ff || typeof ff !== "string") return false;

  return !systemFontsSet.has(ff);
};

export interface Font {
  label: string;
  value: string;
}

export const mergeGoogleFonts = (fonts: string[]) => {
  if (!fonts.length) return;

  ensureRegisteredGoogleFontsInitialized();

  const changed = fonts.reduce((res, f) => {
    const has = registeredGoogleFonts.has(f);
    !has && registeredGoogleFonts.add(f);
    return res || !has;
  }, false);

  changed && setGoogleFontsLink();
};

const pendingGoogleFonts = new Set<string>();
let pendingGoogleFontsTimeout;
export const registerGoogleFont = (font: string | null | undefined) => {
  if (!font || !isGoogleFont(font)) return;

  if (pendingGoogleFonts.has(font)) return;

  if (pendingGoogleFontsTimeout) {
    clearTimeout(pendingGoogleFontsTimeout);
  }

  debug(`Registered ${font} google fonts`);
  pendingGoogleFonts.add(font);

  pendingGoogleFontsTimeout = setTimeout(() => {
    const fonts = [...pendingGoogleFonts];
    pendingGoogleFonts.clear();

    debug(`Applying ${fonts} google fonts`);
    mergeGoogleFonts(fonts);
  }, 0);
};
